<template>
  <div class="f-p">
    <div class="f-p-data">
      <fm-table
        :column-list="columnList"
        :data-list="[{}].concat(formParmsData)"
        @tableAction="tableAction"
        :table-actions="tableActions">
      </fm-table>
    </div>
    <fm-form-dialog
      form-title="表单配置"
      :open-dialog.sync="openDialog"
      :form-parms="formParms"
      :old-data="chooseData"
      label-alone
      label-align="left"
      form-width="800px"
      @formSubmit="formSubmit"
      @handleClose="handleClose">
    </fm-form-dialog>
  </div>
</template>

<script>
let dcopy = require('deep-copy')

export default {
  props: {
    value: Array
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
    columnList () {
      return [{
        title: '名称',
        field: 'label'
      },
      {
        title: '键',
        field: 'key'
      },
      {
        title: '类型',
        field: 'type',
        render: function (h, rowData) {
          return h('div', ([{key: 'input', label: '输入'}, {key: 'select', label: '选择'}].find(v => v.key === rowData.type) || {}).label || '')
        }
      }]
    },
    formParms () {
      return [{
        type: 'input',
        label: '名称',
        key: 'label',
        check: {
          required: true
        }
      },
      {
        type: 'input',
        label: '键',
        key: 'key',
        fmDisabled: !this.isNew,
        check: {
          required: true
        }
      },
      {
        type: 'select',
        label: '类型',
        key: 'type',
        selectDatas: [{key: 'input', label: '输入'}, {key: 'select', label: '选择'}],
        check: {
          required: true
        }
      }]
    }
  },
  data () {
    return {
      isNew: false,
      chooseData: null,
      tableActions: [{
        key: 'add',
        label: '新增',
        show: (data) => {
          return !data.key
        }
      },
      {
        key: 'edit',
        label: '修改',
        show: (data) => {
          return data.key
        }
      },
      {
        key: 'del',
        label: '删除',
        show: (data) => {
          return data.key
        }
      }],
      formParmsData: [],
      openDialog: false
    }
  },
  watch: {
    value: {
      handler () {
        this.formParmsData = dcopy(this.value)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    tableAction (parm) {
      if (parm.action === 'add') {
        this.isNew = true
        this.chooseData = null
        this.openDialog = true
      } else if (parm.action === 'edit') {
        this.chooseData = parm.data
        this.openDialog = true
        this.isNew = false
      } else if (parm.action === 'del') {
        this.chooseData = parm.data
        this.formParmsData = this.formParmsData.filter(v => v.key !== this.chooseData.key)
        this.$emit('change', this.formParmsData.map((v) => {
          let a = {}
          Object.keys(v).forEach((v2) => {
            a[v2] = v[v2]
          })
          return a
        }))
      }
    },
    handleClose () {
      this.openDialog = false
    },
    formSubmit (data) {
      if (this.isNew) {
        if (!this.formParmsData.find(v => v.key === data.key)) {
          this.formParmsData.push(data)
        }
      } else {
        let i = 0
        while (i < this.formParmsData.length) {
          if (this.formParmsData[i].key === data.key) {
            this.formParmsData[i] = data
          }
          i += 1
        }
      }
      this.$emit('change', this.formParmsData.map((v) => {
        let a = {}
        Object.keys(v).forEach((v2) => {
          a[v2] = v[v2]
        })
        return a
      }))
      this.openDialog = false
    },
    conf () {
      this.openDialog = true
    }
  }
}
</script>

<style lang="less" scoped>
@import './base.less';
.f-p {
  align-items: center;
  margin-left: 1rem;
  width: calc(100% - 1rem);
  .f-p-data {
    border: 1px solid #dcdee2;
    border-top: 0px;
    height: 10rem;
    width: calc(100% - 1rem);
  }
}
</style>
